import React, { Component } from 'react'
import {
  MuiTypography, muiWithStyles, MuiGrid, MuiButton, MuiTable,
  MuiTableCell, MuiTableBody, MuiTableRow, MuiTableHead, MuiTableContainer, MuiHomeIcon
} from '../../ui/MaterialUIComponents'
import theme from '../../../assests/theme'
import moment from 'moment';
import SubscriptionDialogComponent from './SubscriptionDialogComponent'
import CancelSubscriptionAlertDialogComponent from './CancelSubscriptionAlertDialogComponent'
import lodashUtils from 'lodash'
import PageHeaderComponent from '../../ui/PageHeaderComponent'
import routes from "../../navigation/Routes";
import { Link } from "react-router-dom";
import * as StringReplacer from '../../../i18n/StringReplacer'
import ConfirmDeleteDialog from './ConfirmDeleteDialog'
import { truncate } from 'fs';
const useStyles = theme => ({

});



export class SubscriptionComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showHelpMessage: false,
      openDeleteDialog: false
    }
  }
  getTotalTimetableCount = (subscriptionTimetableCount, addOns) => {
    if (addOns != undefined && addOns.length > 0) {
      let addOnsTimetables = lodashUtils.filter(addOns, { 'status': 'active' });
      if (addOnsTimetables != undefined && addOnsTimetables.length > 0) {
        for (let i = 0; i < addOnsTimetables.length; i++) {
          subscriptionTimetableCount = Number(subscriptionTimetableCount) + Number(addOnsTimetables[i].quantity);
        }
        return subscriptionTimetableCount;
      } else {
        return subscriptionTimetableCount
      }
    } else {
      return subscriptionTimetableCount
    }
  }
  handleClickOpenDialog = (event, action, school) => {
    this.setState({ openDialog: true, action: action, licenseeSchool: school });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false, action: null, licenseeSchool: null, showHelpMessage: false, helpMessage: "" });
  }
  handleClickOpenCancelSubscriptionDialog = (owenerId, school) => {
    this.setState({ openCancelAlertDialog: true, cancelSubscriptionForOwenerId: owenerId, cancelSubscriptionForSchool: school });
  }
  agreeCancelSubsciption = () => {
    this.handleCloseCancelSubscriptionDialog();
    this.props.cancelSubscription(this.state.cancelSubscriptionForOwenerId, this.state.cancelSubscriptionForSchool);
  }
  handleCloseCancelSubscriptionDialog = () => {
    this.setState({ openCancelAlertDialog: false });
  }
  subscribe = (event, action, school, numberOfSections) => {

    switch (action) {
      case "buyLicense":
        if (school.school_master.totalNumberOfGroups < Number(this.props.i18n.license.minimumNumberOfGroup)) {
          if (numberOfSections >= Number(this.props.i18n.license.minimumNumberOfGroup)) {
            this.props.getSubscription(event, school, numberOfSections)
            this.handleCloseDialog()
          } else {
            this.setState({ helpMessage: StringReplacer.getFormatedMessage(this.props.i18n.license.minimumNumberOfGroupHelpMessage, { minimumNumberOfGroup: this.props.i18n.license.minimumNumberOfGroup }), showHelpMessage: true })
          }
        } else {
          if (numberOfSections >= school.school_master.totalNumberOfGroups) {
            this.props.getSubscription(event, school, numberOfSections)
            this.handleCloseDialog()
          } else {
            this.setState({ helpMessage: StringReplacer.getFormatedMessage(this.props.i18n.license.minimumNumberOfGroupHelpMessage, { minimumNumberOfGroup: school.school_master.totalNumberOfGroups }), showHelpMessage: true })
          }
        }
        break;
      case "buyMoreSections":
        let subscribingPackage = {
          numberOfSections: numberOfSections,
          school: school
        }
        this.handleCloseDialog()
        this.props.updateSubscription(this.props.userInformation._id, subscribingPackage);
        break;
      case "buyMoreTimetables":
        let addMoreTimeTablesToSubscription = {
          additionalTimetables: numberOfSections,
          school: school
        }
        this.handleCloseDialog()
        //this.props.addMoreTimetablesToSubscription(this.props.userInformation._id,addMoreTimeTablesToSubscription);
        this.props.addMoreTimetables(event, school)
        break;
    }


  }
  openDeleteDialogMethod = (event, index) => {
    this.setState({ openDeleteDialog: true, schoolIndex: index });
  };
  closeDeleteDialogMethod = event => {
    this.setState({ openDeleteDialog: false, schoolIndex: null });
  };
  onClickDelete = (schoolId) => {
    this.props.deleteSchool(schoolId)
    this.closeDeleteDialogMethod()
  }
  deleteDialog = () => {

    const { classes } = this.props
    return (
      <MuiGrid container xs={12}>
        <ConfirmDeleteDialog {...this.props} schoolId={this.props.schoolsSummary[this.state.schoolIndex]._id} name={this.props.schoolsSummary[this.state.schoolIndex].name} onClickDelete={this.onClickDelete} cancel={this.closeDeleteDialogMethod} open={this.state.openDeleteDialog} />
      </MuiGrid>
    )
  }
  isDelitionAllowed = (nextBillingDate, status) => {
    let nbd = new Date(nextBillingDate.substring(0, 4), nextBillingDate.substring(5, 7), nextBillingDate.substring(8, 10))
    let today = new Date();
    if (status.toLowerCase() === 'trial period' || nbd.getTime() < today.getTime()) {
      return true
    } else {
      return false
    }
  }
  getTableCell = () => {
    const i18n = this.props.i18n
    let rowArray = []
    for (let i = 0; i < this.props.schoolsSummary.length; i++) {
      let cellArray = []
      cellArray.push(<MuiTableCell align="center">
        <MuiGrid container direction='column'>
          <MuiGrid item xs>{this.props.schoolsSummary[i].name}</MuiGrid>
        </MuiGrid>
      </MuiTableCell>
      )
      // cellArray.push(<MuiTableCell align="center">
      //   <MuiGrid container direction='column'>
      //     <MuiGrid item xs>{this.props.schoolsSummary[i].licenseId.status}</MuiGrid>
      //     <MuiGrid item xs><MuiButton variant="contained" color="primary">Buy Licence</MuiButton></MuiGrid>
      //   </MuiGrid>
      // </MuiTableCell>
      // )
      let today = moment(new Date()).format('MM-DD-YYYY')
      let expirationDay = moment(this.props.schoolsSummary[i].license.nextBillDate).format('MM-DD-YYYY')
      //&& expirationDay > today
      if (this.props.schoolsSummary[i].license.status.toLowerCase() == 'active') {
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={{ color: '#228B22', fontWeight: 600 }} variant="body1" display="block" gutterBottom>{this.props.schoolsSummary[i].license.status.toUpperCase()}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiTypography style={{ color: '#228B22', fontWeight: 600 }} variant="body1" display="block" gutterBottom>Expires on {moment(this.props.schoolsSummary[i].license.nextBillDate).format('MM-DD-YYYY')}</MuiTypography></MuiGrid>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{this.props.schoolsSummary[i].school_master && this.props.schoolsSummary[i].school_master.totalNumberOfGroups ? this.props.schoolsSummary[i].school_master.totalNumberOfGroups : 0}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{"( Allowed " + this.props.schoolsSummary[i].license.sectionsQuantity + " )"}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} onClick={(event) => this.handleClickOpenDialog(event, "buyMoreSections", this.props.schoolsSummary[i])} fullWidth>{i18n.license.buyMoreSections}</MuiButton></MuiGrid>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{this.props.schoolsSummary[i].license.usedTimetableCount}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{"( Allowed " + this.props.schoolsSummary[i].license.timeTableQuantity + " )"}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} onClick={(event) => this.props.addMoreTimetables(event, this.props.schoolsSummary[i])} fullWidth>{i18n.license.buyMoreTimetables}</MuiButton></MuiGrid>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom> &nbsp;</MuiTypography> </MuiGrid>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom> &nbsp;</MuiTypography> </MuiGrid>
            <MuiGrid item xs> <Link to={{
              pathname: routes.orderHistory,
              state: {
                schoolId: this.props.schoolsSummary[i]['_id'],
                schoolName: this.props.schoolsSummary[i]['name']
              }
            }} style={{ cursor: 'pointer', textDecoration: 'none' }}><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} fullWidth>
                Order History
            </MuiButton> </Link></MuiGrid>
            {/* <MuiGrid item xs><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} onClick={() => this.handleClickOpenCancelSubscriptionDialog(this.props.userInformation._id, this.props.schoolsSummary[i])} fullWidth>{i18n.license.cancelSubscription}</MuiButton></MuiGrid> */}
          </MuiGrid>
        </MuiTableCell>
        )
      } else {
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid item xs>

          </MuiGrid>
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={{ color: '#228B22', fontWeight: 600 }} variant="body1" display="block" gutterBottom>{this.props.schoolsSummary[i].license.status.toUpperCase()}</MuiTypography></MuiGrid>
            <MuiTypography style={{ color: '#228B22', fontWeight: 600 }} variant="body1" display="block" gutterBottom>Expires on {moment(this.props.schoolsSummary[i].license.nextBillDate).format('MM-DD-YYYY')}</MuiTypography>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{this.props.schoolsSummary[i].school_master && this.props.schoolsSummary[i].school_master.totalNumberOfGroups ? this.props.schoolsSummary[i].school_master.totalNumberOfGroups : 0}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{"( Allowed " + this.props.schoolsSummary[i].license.sectionsQuantity + " )"}</MuiTypography></MuiGrid>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{this.props.schoolsSummary[i].license.usedTimetableCount}</MuiTypography></MuiGrid>
            <MuiGrid item xs><MuiTypography style={theme.typography.body1} display="block" gutterBottom>{"( Allowed " + this.props.schoolsSummary[i].license.timeTableQuantity + " )"}</MuiTypography></MuiGrid>
          </MuiGrid>
        </MuiTableCell>
        )
        cellArray.push(<MuiTableCell align="center">
          <MuiGrid container direction='column'>
            <MuiGrid item xs><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} onClick={(event) => this.handleClickOpenDialog(event, "buyLicense", this.props.schoolsSummary[i])} fullWidth>{i18n.license.buyLicense}</MuiButton></MuiGrid>
            <MuiGrid item xs>&nbsp;</MuiGrid>
            {this.props.schoolsSummary[i].license.status.toLowerCase() !== "trial period" ? <MuiGrid item xs> <Link to={{
              pathname: routes.orderHistory,
              state: {
                schoolId: this.props.schoolsSummary[i]['_id'],
                schoolName: this.props.schoolsSummary[i]['name']
              }
            }} style={{ cursor: 'pointer', textDecoration: 'none' }}><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} fullWidth>
                Order History
            </MuiButton> </Link></MuiGrid> : null}
            <MuiGrid item xs>&nbsp;</MuiGrid>
            {this.isDelitionAllowed(this.props.schoolsSummary[i].license.nextBillDate, this.props.schoolsSummary[i].license.status) ? <MuiGrid item xs><MuiButton disabled={this.props.isButtonDisabled} style={this.props.isButtonDisabled !== true ? theme.primaryButtonStyle : null} onClick={(event) => this.openDeleteDialogMethod(event, i)} fullWidth>{i18n.license.deleteSchool}</MuiButton></MuiGrid> : null}
          </MuiGrid>
        </MuiTableCell>
        )
      }
      let row = <MuiTableRow hover>{cellArray}</MuiTableRow>
      rowArray.push(row);
    }
    return rowArray;
  }

  render() {

    const { classes, i18n } = this.props;
    return (
      <MuiGrid container style={{ marginTop: '75px' }} alignItems='center' justify='center' xs={12}>
        {this.state.openDeleteDialog ? this.deleteDialog() : null}
        <MuiGrid xs={11}>
          <Link
            style={{ textDecoration: 'none', cursor: 'pointer' }}
            to={{
              pathname: routes.main,
            }}
          ><MuiGrid container xs={11}>
              <MuiGrid item >

                <MuiHomeIcon color='primary' size='medium' />

              </MuiGrid>

              <MuiGrid item  >
                <MuiTypography align="left" variant={theme.typographyStyles.H3} color='primary' >
                  &nbsp;&nbsp;{this.props.activeSchool.name}
                </MuiTypography>
              </MuiGrid> </MuiGrid>    </Link>
        </MuiGrid>

        <MuiGrid container xs={11} style={{ padding: '10px 0px' }}>
          <PageHeaderComponent {...this.props} title={i18n.license.title}
            subTitle={i18n.license.subTitle} />
        </MuiGrid>

        {this.props.isButtonDisabled ? <MuiGrid xs={11}>
          <MuiTableContainer>
            <MuiTable aria-label="simple table" className={this.props.table} >
              <MuiTableHead style={theme.tableHeaderStyle1}>
                <MuiTableRow>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >
                    {/* <marquee direction="right" speed="normal" behavior="loop" > */}
                    {i18n.license.transactionNote}
                    {/* </marquee> */}
                  </MuiTableCell>
                </MuiTableRow>
              </MuiTableHead>
            </MuiTable>
          </MuiTableContainer>
        </MuiGrid> : null}
        <MuiGrid container xs={11} style={{ padding: '10px 0px' }}>
        </MuiGrid>
        <MuiGrid xs={11}>
          <MuiTableContainer>
            <MuiTable aria-label="simple table" className={this.props.table} >
              <MuiTableHead style={theme.tableHeaderStyle1}>
                <MuiTableRow>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{i18n.license.schoolName}</MuiTableCell>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{i18n.license.licenceStatus}</MuiTableCell>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{i18n.license.groups}</MuiTableCell>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{i18n.license.timetables}</MuiTableCell>
                  <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{i18n.license.actions}</MuiTableCell>
                </MuiTableRow>
              </MuiTableHead>
              <MuiTableBody>
                {this.getTableCell()}
              </MuiTableBody>
            </MuiTable></MuiTableContainer>
          {this.state.openDialog ?
            <SubscriptionDialogComponent {...this.state} openDialog={this.state.openDialog}
              handleCloseDialog={this.handleCloseDialog}
              subscribe={this.subscribe}
              i18n={i18n}
            /> : null}
          {this.state.openCancelAlertDialog ?
            <CancelSubscriptionAlertDialogComponent {...this.state} openCancelAlertDialog={this.state.openCancelAlertDialog}
              handleClickOpenCancelSubscriptionDialog={this.handleClickOpenCancelSubscriptionDialog}
              agreeCancelSubsciption={this.agreeCancelSubsciption}
              handleCloseCancelSubscriptionDialog={this.handleCloseCancelSubscriptionDialog}
              i18n={i18n}
            /> : null}
        </MuiGrid></MuiGrid>
    )
  }
}

export default muiWithStyles(useStyles)(SubscriptionComponent)